const ENV_KEYS = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_APP_ID',
  'VITE_FIREBASE_MESSAGING_SENDER_ID'
] as const;

export function getMissingFirebaseEnvKeys(): string[] {
  const env = import.meta.env;
  return ENV_KEYS.filter((key) => {
    const v = env[key as keyof ImportMetaEnv];
    return !v || String(v).trim() === '' || String(v).startsWith('PASTE_');
  });
}

export function isFirebaseConfigured(): boolean {
  return getMissingFirebaseEnvKeys().length === 0;
}
